import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";
import { FormLabel, TextField,Button } from "@material-ui/core";

import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function ViewCourses() {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [search, setSearch] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [cources, setCources] = useState([]);
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [rowCount, setRowCount] = useState("");

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage);
  };

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editcource") {
      navigate(`/admin/editcource/${rowId}`);
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async (pageNumber, size) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course?page=${
          pageNumber + 1
        }&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setCources(response.data.courses);
      setRowCount(response.data.count);
      console.log("response course", response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    if (
      onPage !== undefined &&
      pageSize !== undefined &&
      searchQuery !== undefined
    ) {
      fetchData(onPage, pageSize, searchQuery);
    }
  }, [onPage, pageSize, searchQuery]);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      fetchData(onPage, pageSize, searchQuery);
      handleClose();
      toast.success("Course deleted successfully");
      const updateddatatata = cources.filter((data) => data.id !== rowId);
      setCources(updateddatatata);
    } catch (error) {
      toast.error("Course is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      course: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/status`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      })
      .then((response) => {
        console.log("Course status changed successfully", response);
        fetchData(onPage, pageSize, searchQuery);
        toast.success("Course status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Course status:", error);
        toast.error("Course status is not changed");
      });
  };

  const rows = cources.map((d) => ({
    id: d.id ? d.id : "N/A",
    course_name: d.course_name ? d.course_name : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
  }));
  const startIndex = onPage * pageSize;
  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d.course_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "course_name",
      headerName: "Course Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center", // Align the column header to center
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div
          className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
          style={{ height: "100%" }}
        >
          {cellValues.value}
        </div>
      ),
    },

    // {
    //   field: "students",
    //   headerName: "Students",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 110,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   flex: 2,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <Link>Quizzes</Link>
    //         <Link>Notes</Link>
    //         <Link> Quizzes </Link>
    //         <Link> Test Series </Link>
    //         <Link> Previous year paper</Link>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";

        return (
          <div
            className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editcource", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      inputplaceholder: "Search course name",
      export: "yes",
      import: "yes",
      exportFileName: "Courses.csv",
      importApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/import`,
      exportApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/export/all`,
      fetchData: () => fetchData(onPage, pageSize),
    },
  ];

  const style = [
    {
      height: "maxh67",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableViewSearch Heading={Heading} onSearch={handleSearch} />

        <div
          className={`${classes.dflex} ${classes.m0_5}`}
        >
         
          {/* <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
            >
              Search
            </FormLabel>
            <TextField
              type="text"
              variant="outlined"
              required
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Course Name"
            />
          </div>

          <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}`}
          >
            <Button
              className={`${classes.custombtnblue} ${classes.mt1_5} ${classes.ml0_5}`}
              onClick={()=>fetchData(onPage, pageSize)}
            >
              search
            </Button>
          </div> */}
          {/* <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          ></div> */}
        </div>
        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>
    </>
  );
}
export default ViewCourses;
